export default __webpack_public_path__ + "static/media/bank.f47ad676.svg";